import * as Pace from 'pace-js/pace';

document.addEventListener('DOMContentLoaded', function () {
    if(document.body.classList.contains("pace-primary")){
        window.addEventListener('beforeunload', (event: BeforeUnloadEvent) => {
            Pace.options = {
                ghostTime: 2500000
            };
            Pace.restart();
        }, {once : true});
    }
});